import { selectTranslator } from 'core/redux/features/languages/trans';
import { AppState } from 'core/redux/reducers';
import { createSelector } from 'reselect';

export interface ViewMode {
  id: string;
  uri: string[];
  label: string;
  transKey: string;
  route: string;
  key: number;
}

export type ViewModeRecords = Record<string, ViewMode>;

export const viewModes = {
  desc: {
    id: 'desc',
    uri: ['desc', 'description'],
    label: 'THE RESTAURANT',
    transKey: 'the_resto',
    route: 'desc',
    key: 0,
  },
  menu: {
    id: 'menu',
    uri: ['menu'],
    label: 'MENU',
    transKey: 'menu',
    route: 'menu',
    key: 0,
  },
  gallery: {
    id: 'gallery',
    uri: ['galleri'],
    label: 'GALLERY',
    transKey: 'gallery',
    route: 'galleri',
    key: 0,
  },
  address: {
    id: 'address',
    uri: ['location'],
    label: 'ADDRESS',
    transKey: 'address',
    route: 'location',
    key: 0,
  },
};

export const selectViewModes = createSelector(
  [
    selectTranslator,
    (state: AppState) => state.products.activeProductType,
    (_: AppState) => viewModes,
  ],
  (_trans, type, viewModes) => {
    let label = viewModes.desc.label;
    let transKey = viewModes.desc.transKey;
    if (type === 'bar') {
      label = 'THE BAR';
      transKey = 'the_bar';
    }

    return {
      ...viewModes,
      desc: {
        ...viewModes.desc,
        transKey,
        label,
      },
    };
  },
);

export const getViewModeFromHash = createSelector(
  [(hash: string) => hash],
  (hash: string): ViewMode => {
    let viewMode: ViewMode = viewModes['desc'];
    const viewFind = hash?.replace('#', '');
    if (!viewFind) {
      return viewMode;
    }

    const find = Object.values<ViewMode>(viewModes).find(mode => {
      return mode.uri.find(f => f === viewFind);
    });

    if (find) {
      viewMode = find;
    }

    return viewMode;
  },
);

export const getViewModeFromSearchString = createSelector(
  [(searchStr: string) => searchStr],
  (searchStr: string): ViewMode => {
    const searchParams = new URLSearchParams(searchStr);
    const viewFind = searchParams.get('view');
    let viewMode: ViewMode = viewModes['desc'];
    const viewKey: any = searchParams.get('i');

    if (!viewFind) {
      return viewMode;
    }

    const find = Object.values<ViewMode>(viewModes).find(mode => {
      return mode.uri.find(f => f === viewFind);
    });

    if (find) {
      viewMode = find;
    }

    if (viewKey) {
      viewMode.key = viewKey;
    }

    return viewMode;
  },
);
